export function addLeadingZero(time, length = 2) {
  return time
    .split(":")
    .map((el) => el.padStart(length, 0))
    .join(":");
}
